import listActions from '../../../modules/productCategory/list/productCategoryListActions'
import ProductCategoryService from '../../../modules/productCategory/productCategoryService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'PRODUCTCATEGORY_DESTROY'

const productCategoryDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: productCategoryDestroyActions.DESTROY_STARTED,
      })

      await ProductCategoryService.destroyAll([id])

      dispatch({
        type: productCategoryDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.productCategory.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/product-category'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: productCategoryDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: productCategoryDestroyActions.DESTROY_ALL_STARTED,
      })

      await ProductCategoryService.destroyAll(ids)

      dispatch({
        type: productCategoryDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.productCategory.destroyAll.success'),
      )

      dispatch(push('/product-category'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: productCategoryDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default productCategoryDestroyActions
